const ProjectState = () => {
  return {
    mainimg: "",
    title: "",
    price: 0,
    period: {
      start: "",
      finish: "",
    },
    finish_time: "",
    category: "dev",
    field: {
      rough: "",
      detail: [
        {
          IUD: "I",
          attd_amt: 0,
          rcrt_ctts: "",
          rcrt_nm: "",
          rcrt_type_cd: "design",
          rcrt_usr_cnt: 1,
        },
      ],
    },
    leader: {
      id: "",
      img: "",
      title: "",
      sub: "",
      link: "",
      name: "",
      intro: "",
    },
    pnlt_lst: [],
    rewards: [],
    template: "",
  };
};

const MeetupState = () => {
  return {
    mainimg: "",
    title: "",
    period: {
      start: "",
      finish: "",
    },
    finish_time: "",
    category: "ONLINE",
    max: 0,
    leader: {
      id: "",
      img: "",
      title: "",
      sub: "",
      link: "",
      name: "",
      intro: "",
    },
    address: {
      basic: "",
      detail: "",
    },
    price: "",
    pnlt_lst: [],
    template: "",
  };
};
const MagazineState = {
  mainimg: "",
  title: "",
  category: "MGN_01",
  leader: {
    id: "",
    sub: "",
    name: "",
  },
  template: "",
  link: "",
};

const AddState = {
  bg_color: "Black",
  ctts_id: "",
  ctts_ctts: "",
  ad_thumbnail: "",
  ctts_link: "",
  ctts_tit: "",
  btn_label: "",
  ctts_ctg_cd: "normal",
};

const CouponState = {
  title: "",
  period: "",
  percent: "",
  type: "mtup",
  list: [],
};

export { ProjectState, MeetupState, AddState, CouponState, MagazineState };
